module.exports = __webpack_public_path__ + "img/JA.9affa298.png";